/**
 * Renders an organization cell as a link to the customer details page.
 * Shows organizationName if available, falls back to publicId, or "—" if neither exists.
 * Used across all table Organization columns for consistent display.
 */
import React from "react";
import { CellRoute } from "./CellLink";

type CellOrganizationProps = {
  customer?: { publicId?: string | null; organizationName?: string | null } | null;
};

export function CellOrganization({ customer }: CellOrganizationProps): React.ReactElement {
  const publicId = customer?.publicId;
  const label = customer?.organizationName || publicId;
  if (!publicId || !label) return <>{label || "—"}</>;
  return <CellRoute route={["customer", { publicId }]} children={label} />;
}
